import {
  DomainAPI,
  Channel,
  APIKey,
  SecretApiKey,
  SecretApiKeyExpires
} from "../utils/setting";

import jwt from "jsonwebtoken";
const district = {
  state: {
    district: []
  },
  reducers: {
    setState(state, payload) {
      this.state = { ...state, ...payload };
      return { ...this.state };
    }
  },
  effects: {
    async getDistrict(payload, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/public/districts/getDistrict";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      return fetch(url, {
        method: "GET",
        headers: myHeaders
      })
        .then(res => res.json())
        .then(result => {
          if (result.code === 1) _this.setState({ district: result.data });
          return result;
        })
        .catch(error => {
          return { code: 0, error: error, message: error.toString() };
        });
    }
  }
};

export default district;
